/*
  西班牙语（es）
*/
export default {
  headerBar: {
    allProducts: 'Todos los productos',
    newIn: 'Añadir entrada',
    bestSellers: 'Best seller',
    specialOffer: 'Ofertas especiales',
    explore: 'Exploración',
    fashionTrends: 'Tendencia de la moda',
    whyUs: '¿Por qué nosotros?',
    helpCenter: 'Centro de ayuda',
    company: 'Empresa',
    dropshipping: 'Envío directo',
    aboutUs: 'Sobre nosotros',
    blog: 'Blog',
    login: 'Login name',
    register: 'Registro gratuito',
    searchingFor: 'Buscando',
    wishList: 'Lista de deseos',
    listing: 'Catálogo',
    allOrder: 'Todos los pedidos',
    accountSetting: 'Configuración de la cuenta',
    logOut: 'Desconexión',
    home: 'Hogar',
    startSelling: 'Iniciar ventas',
    wholesale: 'Comercio al por mayor'
  },
  indexPage: {
    hello: 'Hola!',
    allCategory: 'Todas las categorías',
    apparelWholesale: 'Comercio al por mayor de prendas de vestir',
    smartDropshiping: 'Arrastrar y soltar inteligente',
    smallMOQCustomization: 'Pequeña personalización moq',
    fastWorldwideShipping: 'Envío mundial rápido',
    estimateShippingCost: 'Costo estimado del transporte',
    flashSale: 'Ventas de relámpagos',
    customization: 'Personalización',
    customizationText1: 'Con más de 500 proveedores y más de 100 diseñadores,',
    customizationText2: 'Los productos exclusivos sólo se pueden personalizar para usted.',
    ins: 'Elección del influenciador',
    insText1: 'Los últimos modelos de moda para obtener ropa inspo.',
    insText2: 'Proporcione el mismo diseño para sus ventas.',
    youMayLike: 'Puede que te guste',
    viewMore: 'Ver más información'
  },
  Index: {
    Similar: {
      Home: 'Hogar',
      VisualSearch: 'Búsqueda visual',
      Products: 'productos',
      UploadAPicture: 'sube una foto',
      Tips1: 'subir imagen para buscar y emparejar',
      Tips2: 'Máx. 2 MB por imagen',
      INeedCustomization: 'Necesito personalización'
    },
    ShoppingCar: {
      Back: 'Atrás',
      ShippingAddress: 'Dirección de envío',
      China: 'Porcelana',
      Tips1: 'Realice envíos a más de 200 países de todo el mundo.',
      Germany: 'Alemania',
      Tips2: 'Envíe artículos solo dentro del país.',
      Tips3: 'Por ejemplo: los productos de EE. UU. solo se admiten para envíos a EE. UU.',
      Edit: 'Editar',
      Choose: 'Elegir',
      AddNewAddress: 'Agregar nueva dirección',
      ShoppingBag: 'Bolsa de la compra',
      Tips4: 'Hay artículos que de',
      Warehouses: 'almacenes',
      Tips5: 'Los artículos de diferentes almacenes no se pueden retirar al mismo tiempo.',
      ItemsFrom: 'artículos de',
      Tips6: 'El almacén solo puede enviar dentro del país.',
      SelectAll: 'Seleccionar todo',
      Delete: 'Borrar',
      Weight: 'Peso',
      Subtotal: 'Total parcial',
      YourBagIsEmpty: 'tu bolsa esta vacia',
      StartShopping: 'Empieza a comprar',
      DeliveryMethod: 'Método de entrega',
      LogisticsError: 'Error de logística',
      Tips7: 'Conecta con nuestro equipo de soporte para continuar',
      AddKakaCloCode: 'Agregar Código KakaClo',
      Apply: 'Aplicar',
      Tips8: 'Deducción por el precio más alto del producto',
      OrderAmount: 'Total de la orden',
      ShippingFee: 'Gastos de envío',
      Discount: 'Descuento',
      PromoCode: 'Código promocional',
      Total: 'Total',
      YouHaveSelected: 'Usted ha seleccionado',
      OutOf: 'fuera de',
      ToCheckout: 'para revisar',
      Tips9: 'Opciones de pago exprés al finalizar la compra',
      Tips10: 'Aceptamos devolución de productos. Los clientes tienen derecho a solicitar una devolución dentro de los 14 días posteriores a la recepción del producto. Para ser elegible para una devolución, su artículo debe estar sin usar y en las mismas condiciones en que lo recibió. También debe estar en el embalaje original. Para completar su devolución, requerimos un recibo o comprobante de compra. Por favor, no devuelva su compra al fabricante.',
      Tips11: 'Para problemas posteriores a la venta, los compradores deben presentar una solicitud de devolución y reembolso dentro de los 30 días posteriores al día de entrega. Una vez que el comprador envía la solicitud de posventa, debe proporcionar pruebas (como se indica en la cláusula a continuación) al kakaclo. Si el comprador no puede proporcionar pruebas convincentes a tiempo, los kakaclo tienen derecho a rechazar el reembolso o devolver la solicitud.',
      Tips12: 'Si el comprador completa la información de recepción incorrectamente, comuníquese con el servicio de atención al cliente o el personal de atraque a tiempo para confirmar si los productos se han enviado. Si no hay entrega, el comprador puede actualizar la dirección de entrega con la información correcta. Si los productos han sido enviados, el comprador debe comunicarse con la empresa de logística para volver a entregarlos. Si se aprueba la solicitud de reembolso, el comprador debe devolver el producto a su carga y cargar la información de seguimiento de devolución de manera oportuna. Después de que kakaclo reciba los productos devueltos sin ningún daño, se deducirá parte del monto del pedido como costo de reempaquetado y reabastecimiento. Si la mercancía no puede ser redistribuida o devuelta, el comprador correrá con las pérdidas correspondientes.',
      HowToReturn: 'como volver',
      ReturnAndReturnIssues: 'Problemas de devoluciones y devoluciones',
      WrongReceiptInformation: 'Información de recibo incorrecta',
      Tips13: 'Los artículos de diferentes almacenes no se pueden retirar al mismo tiempo.',
      Tips14: '¿Estás seguro de que quieres eliminar todos los artículos de',
      Cancel: 'Cancelar',
      Sure: 'Seguro',
      Tips15: 'Tenga en cuenta: es posible que NO pueda realizar ningún cambio después de la confirmación del pedido',
      DontAskMeAgain: 'no me preguntes de nuevo',
      LetMeCheckAgain: 'Dejame revisar otra vez',
      GotIt: 'Entiendo',
      EnterPromoCode: 'Introduce el código de promoción',
      Tips16: '¿Estás seguro de eliminar este artículo?'
    },
    ShippingCost: {
      Home: 'Hogar',
      EstimateShippingCost: 'Estimar costo de envío',
      ShippingCalculation: 'Cálculo de envío',
      ShipForm: 'Formulario de envío',
      ShipTo: 'Envie a',
      Weight: 'Peso',
      Inquire: 'Preguntar',
      Tips1: 'Proveedor de servicios logísticos',
      DeliveryTime: 'el tiempo de entrega',
      Cost: 'Costo'
    },
    ProductList: {
      Home: 'Hogar',
      // AllProducts: 'Todos los productos',
      AllProducts: 'Centro comercial',
      Category: 'Categoría',
      Prices: 'Precios',
      NoProductFound: 'Ningún producto encontrado',
      Tips1: 'Creemos que te encantarán estos',
      Fabric: 'Tela',
      Price: 'Precio',
      Products: 'Productos',
      ClearAll: 'Limpiar todo',
      Submit: 'entregar',
      ShipFrom: 'Nave de',
      SortWay: 'Forma de clasificación'
    },
    PaymentPage: {
      UnderReview: 'Bajo revisión',
      AuditRejected: 'Auditoría rechazada',
      AvailableBalance: 'Saldo disponible',
      ApplyNow: 'Aplicar de inmediato',
      Tips40seas1: 'No se puede usar para pedidos por debajo de $ 2000',
      PaymentPage: 'Página de pago',
      Tips1: 'Por favor seleccione su método de pago',
      Paypal: 'PayPal',
      Creditcard: 'Tarjeta de crédito',
      Others: 'Otros',
      PayNow: 'Pagar ahora',
      PayLater: 'Pagar después',
      DeliveryMethod: 'Método de entrega',
      Warehouses: 'Almacenes',
      Notes: 'notas',
      CustomizedService: 'Servicio Personalizado',
      Weight: 'Peso',
      ShippingAddress: 'Dirección de envío',
      Choose: 'Elegir',
      Edit: 'Editar',
      OrderAmount: 'Total de la orden',
      Subtotal: 'Total parcial',
      ShippingFee: 'Gastos de envío',
      Discount: 'Descuento',
      PromoCode: 'Código promocional',
      Total: 'Total',
      Tips2: 'Aceptamos devolución de productos. Los clientes tienen derecho a solicitar una devolución dentro de los 14 días posteriores a la recepción del producto. Para ser elegible para una devolución, su artículo debe estar sin usar y en las mismas condiciones en que lo recibió. También debe estar en el embalaje original. Para completar su devolución, requerimos un recibo o comprobante de compra. Por favor, no devuelva su compra al fabricante.',
      Tips3: 'Para problemas posteriores a la venta, los compradores deben presentar una solicitud de devolución y reembolso dentro de los 30 días posteriores al día de entrega. Una vez que el comprador envía la solicitud de posventa, debe proporcionar pruebas (como se indica en la cláusula a continuación) al kakaclo. Si el comprador no puede proporcionar pruebas convincentes a tiempo, los kakaclo tienen derecho a rechazar el reembolso o devolver la solicitud.',
      Tips4: 'Si el comprador completa la información de recepción incorrectamente, comuníquese con el servicio de atención al cliente o el personal de atraque a tiempo para confirmar si los productos se han enviado. Si no hay entrega, el comprador puede actualizar la dirección de entrega con la información correcta. Si los productos han sido enviados, el comprador debe comunicarse con la empresa de logística para volver a entregarlos. Si se aprueba la solicitud de reembolso, el comprador debe devolver el producto a su cargo y cargar la información de seguimiento de devolución de manera oportuna. Después de que kakaclo reciba los productos devueltos sin ningún daño, se deducirá parte del monto del pedido como costo de reempaquetado y reabastecimiento. Si la mercancía no puede ser redistribuida o devuelta, el comprador correrá con las pérdidas correspondientes.',
      Tips5: 'Déjanos tu requerimiento',
      Description: 'Descripción',
      UnitPrice: 'Precio unitario',
      Tags: 'Etiquetas',
      Package: 'Paquete (Próximamente)',
      Bags: 'Bolsas (Próximamente)',
      HowToReturn: 'como volver',
      Tips6: 'Problemas de devoluciones y devoluciones',
      Tips7: 'Información de recibo incorrecta'
    },
    MobileSearchCenter: {
      Cancel: 'Cancelar'
    },
    MobileExploreDetail: {
      Following: 'Siguiente',
      ViewMore: 'Ver más',
      PackUp: 'Empaca',
      ClothingElements: 'Elementos de ropa',
      Color: 'Color',
      Pattern: 'Patrón',
      Material: 'Material',
      Excipients: 'excipientes',
      Style: 'Estilo',
      Gender: 'Género',
      Contour: 'Contorno',
      ShopSimilar: 'Comprar similares',
      UploadAPicture: 'sube una foto'
    },
    Index: {
      LoginExperience: 'Experiencia de inicio de sesión',
      NoRecommendedProduct: 'Ningún producto recomendado',
      ViewMore: 'Ver más'
    },
    FestivalCollection: {
      EventExpried: 'Evento Expirado',
      ViewMore: 'Ver más'
    },
    ExploreCopy: {
      Home: 'Hogar',
      Explore: 'Explorar',
      ShopSimilar: 'Comprar similares',
      Following: 'Siguiente',
      UploadAPicture: 'sube una foto'
    },
    Explore: {
      Area: 'Área',
      ViewMore: 'Ver más',
      ReleaseTime: 'Tiempo de liberación',
      Category: 'Categoría',
      Followers: 'Seguidores',
      DesignElements: 'Elementos de diseño',
      Color: 'Color',
      Style: 'Estilo',
      Tips1: 'Inicia sesión para ver más',
      Login: 'Acceso',
      Tips2: 'Bienvenido a Instagram Moda Explorar',
      SignUp: 'Inscribirse',
      Or: 'o',
      LogIn: 'Acceso',
      Tips3: 'para desbloquear más publicaciones de moda.',
      ClearAll: 'Limpiar todo',
      Filter: 'Filtrar',
      ShopSimilar: 'Comprar similares',
      Following: 'Siguiente',
      SorryNoDataFound: 'Lo sentimos, no se encontraron datos',
      PackUp: 'Empaca',
      ClothingElements: 'Elementos de ropa',
      Pattern: 'Patrón',
      Material: 'Material',
      Excipients: 'excipientes',
      Gender: 'Género',
      Contour: 'Contorno',
      Cancel: 'Cancelar',
      Submit: 'Entregar',
      LoginExperience: 'Experiencia de inicio de sesión',
      UploadAPicture: 'Cargar una imagen',
      Colors: 'Colores',
      Fans: 'Aficionados'
    },
    Discount: {
      OFF: 'OFF',
      EventExpried: 'Evento Expirado'
    },
    Components: {
      UploadPopout: {
        VisualSearch: 'Búsqueda visual',
        Tips1: 'Cargar imagen para buscar y combinar',
        Max5MBPerImage: 'Máx. 5 MB por imagen',
        UploadImage: 'Cargar imagen'
      },
      Time: {
        Days: 'Días'
      },
      ProductEmpty: {
        Tips1: 'No encontró lo que desea, puede hacer clic en "Necesito personalización',
        INeedCustomization: 'Necesito personalización'
      },
      Header: {
        Currency: 'Divisa',
        Save: 'Ahorrar',
        PersonalCenter: 'Centro personal'
      },
      FlashSale: {
        EndsIn: 'Termina en',
        EventExpried: 'Evento Expirado',
        ViewMore: 'Ver más'
      },
      Filter: {
        ClearAll: 'Limpiar todo',
        Filter: 'Filtrar'
      },
      CarFlashTime: {
        EndIn: 'terminar en'
      }
    },
    Album: {
      Components: {
        TemplateTwo: {
          NoProductFound: 'Ningún producto encontrado'
        },
        TemplateOne: {
          All: 'Hacer',
          ViewMore: 'Ver más',
          NoProductFound: 'Ningún producto encontrado'
        }
      }
    },
    IndexPage: {
      title: 'Proveedores de Ropa al por Mayor',
      description: `
      <div>
      Bienvenido a nuestra tienda de ropa al por mayor en línea, tu destino definitivo para una amplia gama de moda a precios mayoristas. En KakaClo, nos enorgullece ofrecer una colección diversa y de moda de ropa al por mayor, asegurando que tu boutique esté abastecida con las últimas tendencias en moda. 
      </div>
      <div>
        Nuestro objetivo principal es ser tu tienda única para todas las necesidades de moda de tu boutique. Aprovechando fuertes conexiones con los mercados locales al por mayor, ofrecemos una impresionante selección de las piezas de moda más modernas y candentes de la industria. Esto incluye una amplia gama, como tops de mujer, camisetas, chaquetas, vestidos de vacaciones, vestidos de fiesta, chaquetas de hombre, pantalones deportivos, ropa interior, ropa de estar y jeans. Entendemos la naturaleza dinámica de la moda y actualizamos constantemente nuestro inventario para proporcionarte las tendencias más frescas y buscadas.
      </div>
      <div>
        Una variedad de estilos para satisfacer a tu boutique.
      </div>
      <div>
        Desde chic y elegante hasta casual y moderno, nuestro inventario abarca un amplio espectro de estilos para satisfacer varias preferencias de moda. Además de la ropa de mujer y hombre, también nos especializamos en la venta al por mayor de ropa diaria y de moda para mujeres embarazadas, ropa de talla grande para mujeres, ropa para padres e hijos, ropa de Halloween, ropa del Día de la Victoria, ropa de Navidad y otras prendas temáticas de festividades. Ofrecemos una amplia gama de accesorios para complementar nuestra colección diversa.
      </div>
      <div>
        Ya sea que el estilo característico de tu boutique gire en torno a ropa elegante para la noche, ropa casual cómoda o piezas llamativas para los amantes de la moda, tenemos una variedad de opciones para satisfacer a tu exigente clientela.
      </div>
      <div>
        Calidad, asequibilidad y conveniencia.
      </div>
      <div>
        La calidad es un aspecto no negociable de nuestra colección de ropa al por mayor. Nos aseguramos de que cada prenda cumpla con altos estándares, combinando diseños de moda con durabilidad. Además, nuestro compromiso de ofrecer precios al por mayor te permite armar una colección de alta calidad a precios asequibles, mejorando tanto tu inventario como tus márgenes de beneficio.
      </div>
      <div>
        ¡Compra ahora y eleva tu boutique!
      </div>
      <div>
        Te invitamos a explorar nuestra plataforma en línea y examinar nuestra selección cuidadosamente elegida. Abastece tu boutique con lo último en tendencias de moda sin comprometer la calidad ni tu presupuesto. Eleva la oferta de tu boutique con nuestra ropa de moda al por mayor y mantén a tus clientes regresando por más.
      </div>
      <div>
        En KakaClo, estamos dedicados a brindar un servicio incomparable y la moda más actual para impulsar el éxito de tu boutique en el competitivo mercado de la moda.
      </div>
      <div>
        ¡Compra ahora y experimenta la fusión de asequibilidad, diversidad y estilo en nuestro centro de moda al por mayor!
      </div>`
    }
  }
}
